<template>
  <div>
    <div class="navs">
      <el-row type="flex" justify>
        <el-col :span="24">
          <div class="title">
            <p>浙江中医药大学夏令营报名网</p>
            <div class="exit" @click="outLogin">
              <img src="../../assets/image/over.png" />退出登录
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <MyDialog v-bind="wholeSituationModalOption" @modalVisiabal="updateVisiabal">
      <template #content>
        <div class="modal-content">
          <p>{{ wholeSituationModalOption.content }}</p>
        </div>
      </template>
      <template #footer>
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="wholeSituationModalOption.HandleOk">确定</el-button>
      </template>
    </MyDialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import MyDialog from './myDialog.vue'
export default {
  name: 'headNav',
  components: { MyDialog },
  data() {
    return {
    };
  },
  created() {
    // 刷新页面重置 vuex 存入浏览器内存中的数据
    this.$store.commit('updateModalOption', {
      modalVisiabal: false,
      title: '',
      content: '',
      className: '',
      HandleOk: () => { }
    })
    // 调用接口获取全部学校列表和当前学校信息
  },
  computed: {
    // 从vuex getters 中拿出全局对话框的信息对象getConfirmModalOption重命名为wholeSituationModalOption
    ...mapGetters({ wholeSituationModalOption: 'getModalOption' })
  },
  methods: {
    // 改变对话框可见性
    updateVisiabal(bool) {
      this.$store.commit('updateModalOption', {
        modalVisiabal: bool
      })
    },
    // 点击对话框取消
    handleCancel() {
      // 修改vuex对话框数据
      this.$store.commit('updateModalOption', {
        modalVisiabal: false
      })
    },
    // 点击退出登录
    outLogin() {
      // 修改vuex对话框数据
      this.$store.commit('updateModalOption', {
        modalVisiabal: true,
        content: '是否退出登录？',
        title: '退出',
        HandleOk: this.logOut
      })
    },
    async logOut() {
      const { data: res } = await this.$http.get('/login/logout')
      if (res.code == 1000) {
        this.$message.success('退出登录成功！')
        this.$router.replace({ path: "/login" });
        this.$store.state.userData = {}
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
      }
      // 修改vuex对话框数据
      this.$store.commit('updateModalOption', {
        modalVisiabal: false,
      })
    },

  },
}

</script>
<style lang='scss' scoped>
.exit {
  position: absolute;
  bottom: 15px;
  right: 20%;
  color: #fff;
  cursor: pointer;

  img {
    width: 13px;
    margin-right: 5px;
  }
}

/deep/ .el-dialog__title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.modal-content {
  text-align: center;
  height: 100%;
  display: flex;
  font-size: 14px;
  color: #333;
  justify-content: center;
  align-items: center;
}

.navs {
  background: linear-gradient(90deg, rgba(24, 144, 255, 1) 0%, rgba(24, 144, 255, 1) 0%, rgba(136, 199, 255, 1) 100%, rgba(136, 199, 255, 1) 100%);
  height: 75px;
  width: 100%;
  height: 72px;

  .title {
    position: relative;

    p {
      text-align: center;
      font-size: 28px;
      color: #fff;
      line-height: 72px;
      font-weight: 700;
    }
  }

}
</style>